const behavior = {};

export { behavior };
